export default __webpack_public_path__ + "static/media/LoadingScreen_Symbol_F.75b76b27.webm";